var _g, _g2, _g3, _g4, _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlacesEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 206,
    viewBox: "0 0 221 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 105,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8337 120.583V121.417C23.8337 121.647 23.6471 121.833 23.417 121.833H18.8337V126.417C18.8337 126.647 18.6471 126.833 18.417 126.833H17.5837C17.3535 126.833 17.167 126.647 17.167 126.417V121.833H12.5837C12.3535 121.833 12.167 121.647 12.167 121.417V120.583C12.167 120.353 12.3535 120.167 12.5837 120.167H17.167V115.583C17.167 115.353 17.3535 115.167 17.5837 115.167H18.417C18.6471 115.167 18.8337 115.353 18.8337 115.583V120.167H23.417C23.6471 120.167 23.8337 120.353 23.8337 120.583Z",
    fill: "#4494FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 57,
    width: 24,
    height: 24,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.375 68.6875V69.3125C178.375 69.4851 178.235 69.625 178.062 69.625H174.625V73.0625C174.625 73.2351 174.485 73.375 174.312 73.375H173.688C173.515 73.375 173.375 73.2351 173.375 73.0625V69.625H169.938C169.765 69.625 169.625 69.4851 169.625 69.3125V68.6875C169.625 68.5149 169.765 68.375 169.938 68.375H173.375V64.9375C173.375 64.7649 173.515 64.625 173.688 64.625H174.312C174.485 64.625 174.625 64.7649 174.625 64.9375V68.375H178.062C178.235 68.375 178.375 68.5149 178.375 68.6875Z",
    fill: "#4494FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203,
    y: 95,
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.916 102.792V103.208C213.916 103.323 213.823 103.417 213.708 103.417H211.416V105.708C211.416 105.823 211.323 105.917 211.208 105.917H210.791C210.676 105.917 210.583 105.823 210.583 105.708V103.417H208.291C208.176 103.417 208.083 103.323 208.083 103.208V102.792C208.083 102.677 208.176 102.583 208.291 102.583H210.583V100.292C210.583 100.177 210.676 100.083 210.791 100.083H211.208C211.323 100.083 211.416 100.177 211.416 100.292V102.583H213.708C213.823 102.583 213.916 102.677 213.916 102.792Z",
    fill: "#4494FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 148,
    width: 16,
    height: 16,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9163 155.792V156.208C52.9163 156.323 52.8231 156.417 52.708 156.417H50.4163V158.708C50.4163 158.823 50.3231 158.917 50.208 158.917H49.7913C49.6763 158.917 49.583 158.823 49.583 158.708V156.417H47.2913C47.1763 156.417 47.083 156.323 47.083 156.208V155.792C47.083 155.677 47.1763 155.583 47.2913 155.583H49.583V153.292C49.583 153.177 49.6763 153.083 49.7913 153.083H50.208C50.3231 153.083 50.4163 153.177 50.4163 153.292V155.583H52.708C52.8231 155.583 52.9163 155.677 52.9163 155.792Z",
    fill: "#4494FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    width: 104,
    height: 97,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 79,
    width: 84,
    height: 8,
    rx: 2,
    fill: "#C2CFE0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 52,
    y: 10,
    width: 84,
    height: 59,
    rx: 2,
    fill: "#C2CFE0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88 35C88 33.8954 88.8954 33 90 33C91.1046 33 92 33.8954 92 35C92 36.1046 91.1046 37 90 37C88.8954 37 88 36.1046 88 35ZM103.8 44.73L97.8 36.73C97.656 36.5448 97.4346 36.4365 97.2 36.4365C96.9654 36.4365 96.744 36.5448 96.6 36.73L92.6 41.9C92.5051 42.0183 92.3616 42.0871 92.21 42.0871C92.0584 42.0871 91.9149 42.0183 91.82 41.9L89.63 39.24C89.4877 39.0626 89.2725 38.9593 89.045 38.9593C88.8175 38.9593 88.6023 39.0626 88.46 39.24L84.21 44.73C84.0745 44.9045 84.0007 45.1191 84 45.34V46.25C84.0054 46.662 84.338 46.9946 84.75 47H103.25C103.662 46.9946 103.995 46.662 104 46.25V45.33C104 45.1136 103.93 44.9031 103.8 44.73Z",
    fill: "#4494FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 109,
    width: 104,
    height: 97,
    rx: 8,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 188,
    width: 84,
    height: 8,
    rx: 2,
    fill: "#C2CFE0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 92,
    y: 119,
    width: 84,
    height: 59,
    rx: 2,
    fill: "#C2CFE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128 144C128 142.895 128.895 142 130 142C131.105 142 132 142.895 132 144C132 145.105 131.105 146 130 146C128.895 146 128 145.105 128 144ZM143.8 153.73L137.8 145.73C137.656 145.545 137.435 145.436 137.2 145.436C136.965 145.436 136.744 145.545 136.6 145.73L132.6 150.9C132.505 151.018 132.362 151.087 132.21 151.087C132.058 151.087 131.915 151.018 131.82 150.9L129.63 148.24C129.488 148.063 129.272 147.959 129.045 147.959C128.818 147.959 128.602 148.063 128.46 148.24L124.21 153.73C124.075 153.905 124.001 154.119 124 154.34V155.25C124.005 155.662 124.338 155.995 124.75 156H143.25C143.662 155.995 143.995 155.662 144 155.25V154.33C144 154.114 143.93 153.903 143.8 153.73Z",
    fill: "#4494FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0,
    y: 103,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 160,
    y: 55,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f",
    x: 201,
    y: 93,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 40,
    y: 146,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlacesEmpty);
export default __webpack_public_path__ + "static/media/places-empty.da91a6bc.svg";
export { ForwardRef as ReactComponent };